module.exports = __webpack_public_path__ + "static/media/patients-icon.2edf2be6.svg";